// Version-drift check for a restored shared link (#244).
//
// Pure helper consumed by components/restore_notice.tsx: a restored token
// carries the app + engine versions it was minted on; if they disagree with the
// running build, the restore banner warns that results may differ. We restore
// anyway (a routine deploy shouldn't break links) — this only makes drift
// visible, which a reproducibility-sensitive tool needs.

import type { ShareFingerprint } from "../lib/share_token";

/**
 * True when a restored token's fingerprint differs from the running build.
 * An empty fingerprint field (an older token, or one minted without it) does
 * not count as a mismatch — we only warn on a positive disagreement.
 */
export function isVersionMismatch(
  fp: ShareFingerprint | null,
  currentApp: string,
  currentEngine: string,
): boolean {
  if (!fp) return false;
  return (
    (fp.app !== "" && fp.app !== currentApp) ||
    (fp.eng !== "" && fp.eng !== currentEngine)
  );
}
